
































import { Opportunity, OpportunityMembershipStatus } from '@/models/opportunities';
import { Actions } from '@/store';
import { ToastsService } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'ConfirmLeaveModal',
  props: {
    opportunity: Object as () => Opportunity,
  },
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
    };
  },
  methods: {
    async leaveOpportunity() {
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(
          Actions.opportunities.changeMembershipStatus,
          { id: this.$route.params.id, status: OpportunityMembershipStatus.None },
        );
        this.$bvModal.hide('confirm-leave-opportunity-modal');
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
  },
});
